import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { Utility, breadcrumbItem, setTimeout$ } from 'src/app/core/common';
import { IrtwadModel, RtwadImagePath, RtwadService } from 'src/app/services/rtwad.service';
import { SharedService } from 'src/app/services/shared.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { SpinnerService } from 'src/app/services/spinner.service';
import { CommunicationEventService } from 'src/app/services/communication-event.service';

@Component({
	selector: 'app-rtwad-detail',
	templateUrl: './rtwad-detail.component.html',
	styleUrls: ['./rtwad-detail.component.scss']
})
export class RtwadDetailComponent {
	imagePath = RtwadImagePath;
	rtwad: IrtwadModel;
	currentUser: any;
	hideSourceLink = false;
	contactLoaded: any;
	breadcrumbData: breadcrumbItem[];


	constructor(private sharedService: SharedService,
		private route: ActivatedRoute,
		private router: Router,
		private spinner: SpinnerService,
		private rtwadService: RtwadService,
		private toastr: ToastrService,
		private location: Location,
		private eventLog: CommunicationEventService) {
		sharedService.me$
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe(async () => { this.currentUser = this.sharedService.me; });
	}

	private unsubscribe$ = new Subject<void>();
	ngOnDestroy() {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}


	async ngOnInit() {
		const id = this.route.snapshot.params['id'];
		this.rtwad = await this.rtwadService.getById(id);
		if (this.rtwad?.Status != 'Started') {
			delete this.rtwad;
			if (this.sharedService.isBrowser)
				this.router.navigateByUrl('/ready-to-work');
			else
				this.sharedService.redirectPermanent('/ready-to-work');
			return;
		}
		this.setSeo();
		await this.rtwadService.setImpression(id);
		this.eventLog.log(this.eventLog.actions.rtwad.viewer.detailView, { RelatedItems: [{ Id: id, Index: 'readytowork', Relation: 'detail' }] });
	}

	setSeo() {
		let title = `${this.rtwad.Title} - آماده به کار`;
		this.sharedService.setTitle(title);
		this.sharedService.setDescriptionMeta(this.rtwad.Brief);
		this.sharedService.setKeywordsMeta('آماده به کار', this.rtwad.Title, ...this.rtwad.Tags);
		this.breadcrumbData = this.rtwadService.getBreadcrumb({ l: Utility.locationSearch(this.rtwad.State, this.rtwad.City) });
	}

	get autoRedirect() { return localStorage.getItem('rtwad-detail-autoRedirect') == 'yes'; }
	set autoRedirect(set: boolean) { localStorage.setItem('rtwad-detail-autoRedirect', set ? 'yes' : 'no'); }

	async replaceState(url: string) {
		this.eventLog.log(this.eventLog.actions.rtwad.viewer.detailRedirect, { RelatedItems: [{ Id: this.rtwad.Id, Index: 'readytowork', Relation: 'detail' }] });
		setTimeout$(() => {
			if (Utility.mobile)
				window.location.replace(url);
			else window.location.href = url;
		}, 200);
		return false;
	}

	async loadContactInfo() {
		if (!this.currentUser || this.contactLoaded) return;
		this.spinner.show('rtwad-contacts');
		this.rtwad = await this.rtwadService.getContactInfo(this.rtwad.Id);
		this.spinner.hide('rtwad-contacts');
		this.contactLoaded = true;
		await this.rtwadService.setGetContactCount(this.rtwad.Id);
		this.eventLog.log(this.eventLog.actions.rtwad.viewer.detailShowContact, { RelatedItems: [{ Id: this.rtwad.Id, Index: 'readytowork', Relation: 'detail' }] });

	}

	back: (back?: boolean) => void = () => {
		// console.log('called');
		if (history.length > 1) {
			this.location.back();
		}
		else {
			// console.log(environment.app.url);
			this.router.navigateByUrl(environment.app.url);
		}
	};

	share() {
		if ((<any>navigator).share) {
			(<any>navigator).share({
				title: this.rtwad.Title,
				// text: this.job.Description,
				url: `${environment.app.url}/ready-to-work/${this.rtwad.Id}`
			}// ).then(() => this.toastr.info('با تشکر از اشتراک گذاری')
			)?.catch(() => this.copy());
		} else {
			this.copy();
		}
	}

	copy() {
		if (Utility.setClipboard(`${environment.app.url}/ready-to-work/${this.rtwad.Id}`)) {
			this.toastr.success('آدرس آگهی کپی شد.');
		}
	}


}
